import { render, staticRenderFns } from "./EventLike.vue?vue&type=template&id=3da0bce0&scoped=true&"
import script from "./EventLike.vue?vue&type=script&lang=js&"
export * from "./EventLike.vue?vue&type=script&lang=js&"
import style0 from "./EventLike.vue?vue&type=style&index=0&id=3da0bce0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da0bce0",
  null
  
)

export default component.exports